import axiosClient from "./axiosClient";
import { IUpdateBillingRateDTO } from "../interfaces/IUpdateBillingRateDTO";
import { IRateDTO, IRateUpsertDTO } from "../interfaces/IRateDTO";

export function saveRate(data: Partial<IUpdateBillingRateDTO>) {
  return axiosClient.post<{ status: string; message: string }>(
    "/billing_rate/add",
    data
  );
}

export function fetchWorkerBillingRates(workerId: number): Promise<IRateDTO[]> {
  return axiosClient
    .get<IRateDTO[]>(`/billing_rate/worker/${workerId}/list`)
    .then((res) => res.data);
}

export function updateBillingRate(rateId: number, data: IRateUpsertDTO) {
  return axiosClient.put<{ status: string; message: string }>(
    `/billing_rate/${rateId}`,
    data
  );
}

export function createBillingRate(data: Partial<IUpdateBillingRateDTO>) {
  return axiosClient.post<{ status: string; message: string }>(
    "/billing_rate/add",
    data
  );
}
